import React, { memo, forwardRef } from "react";
const SvgTau = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M18.584 22.692a6.416 6.416 0 01-2.04-.312 3.002 3.002 0 01-1.512-1.2c-.384-.576-.576-1.4-.576-2.472v-7.512h-2.64a.816.816 0 010-1.632h8.976a.816.816 0 110 1.632h-4.2v7.296c0 .608.096 1.096.288 1.464.192.368.464.632.816.792.352.16.752.24 1.2.24.352 0 .712-.024 1.08-.072.49-.082.96.29.96.787v.067c0 .326-.196.622-.513.7-.146.035-.311.07-.495.102-.432.08-.88.12-1.344.12z"
      />
    </svg>
  );
});
SvgTau.displayName = "SvgTau";
const MemoForwardRef = memo(SvgTau);
export default MemoForwardRef;
